import $ from "jquery";

$(function () {
  if (typeof hbspt === "undefined") {
    console.error("HubSpot script not loaded");
    return;
  }

  const staticFormId = "f9be0cf7-9c38-4d50-8390-5f3e54bb9337";

  hbspt.forms.create({
    region: "na1",
    portalId: "21790357",
    target: "#hsform_stay_informed",
    formId: staticFormId,
    onFormReady: function ($form, ctx) {
      const $submitButton = $form.find(
        'input[type="submit"], button[type="submit"]'
      );
      const $zipField = $form.find("#zip-" + staticFormId);
      const $dobField = $form.find("#date_of_birth-" + staticFormId);
      const $phoneField = $form.find("#phone-" + staticFormId);

      if (!$submitButton.length) {
        return;
      } // Submit button is essential
      // Fields below are optional, so warnings were removed. Script will just not act on them if not found.

      // Date of Birth (DOB) field handling (placeholder, errors, formatter)
      if ($dobField.length) {
        $dobField.attr("placeholder", "MM/DD/YYYY");

        // Clear initial DOB errors
        $dobField
          .closest(".hs-form-field")
          .find(".custom-form-error.custom-dob-error")
          .remove();
        $dobField.removeClass("custom-field-error");

        // Attach Date of Birth auto-formatter
        $dobField.off("input.dobFormatter").on("input.dobFormatter", function () {
          let value = $(this).val().replace(/\D/g, "");
          if (value.length > 8) value = value.substring(0, 8); // Limit to 8 digits (MMDDYYYY)
          let formattedValue = "";
          if (value.length > 0) formattedValue = value.substring(0, 2);
          if (value.length > 2) formattedValue = value.substring(0, 2) + "/" + value.substring(2, 4);
          if (value.length > 4) formattedValue = value.substring(0, 2) + "/" + value.substring(2, 4) + "/" + value.substring(4);
          $(this).val(formattedValue);
        });
      }

      // Clear initial ZIP errors
      if ($zipField.length) {
        $zipField.closest(".hs-form-field").find(".custom-form-error").remove();
        $zipField.removeClass("custom-field-error");
      }

      // --- Phone Number field handling ---
      if ($phoneField.length) {
        $phoneField.attr("placeholder", "nnn-nnn-nnnn");
        $phoneField.closest(".hs-form-field").find(".custom-form-error").remove();
        $phoneField.removeClass("custom-field-error");

        $phoneField.off("input.phoneFormatter").on("input.phoneFormatter", function () {
          let value = $(this).val().replace(/\D/g, ""); // Remove all non-digits
          if (value.length > 10) value = value.substring(0, 10); // Limit to 10 digits
          let formattedValue = "";
          if (value.length > 0) formattedValue = value.substring(0, 3);
          if (value.length > 3) formattedValue = value.substring(0, 3) + "-" + value.substring(3, 6);
          if (value.length > 6) formattedValue = value.substring(0, 3) + "-" + value.substring(3, 6) + "-" + value.substring(6);
          $(this).val(formattedValue);
        });
      }

      // --- ATTACH SUBMIT BUTTON CLICK LISTENER FOR VALIDATIONS ---
      $submitButton.off("click.customValidation").on("click.customValidation", function (event) {
        let isFormValid = true;

        // Clear all previous custom errors
        $form.find('.custom-form-error').remove();
        $form.find('.custom-field-error').removeClass('custom-field-error');

        // --- ZIP VALIDATION ---
        if ($zipField.length) {
          const zipValue = $zipField.val() ? $zipField.val().trim() : "";
          if (zipValue !== "") {
            // UPDATED: Regex now enforces a strict 5-digit format.
            const usZipRegex = /^\d{5}$/;
            if (!usZipRegex.test(zipValue)) {
              const errorMessage = "Please enter a valid 5-digit US ZIP Code.";
              const $errorElement = $('<label class="hs-error-msg custom-form-error">' + errorMessage + '</label>');
              $zipField.closest(".input").after($errorElement);
              $zipField.addClass("custom-field-error");
              isFormValid = false;
            }
          }
        }

        // --- NEW: PHONE NUMBER VALIDATION ---
        if ($phoneField.length) {
          const phoneValue = $phoneField.val() ? $phoneField.val().trim() : "";
          if (phoneValue !== "") {
            const phoneDigits = phoneValue.replace(/\D/g, "");
            if (phoneDigits.length !== 10) {
              const errorMessage = "Please enter a valid 10-digit US phone number.";
              const $errorElement = $('<label class="hs-error-msg custom-form-error">' + errorMessage + '</label>');
              $phoneField.closest(".input").after($errorElement);
              $phoneField.addClass("custom-field-error");
              isFormValid = false;
            }
          }
        }

        // --- DATE OF BIRTH VALIDATION ---
        if ($dobField.length) {
          const dobValue = $dobField.val() ? $dobField.val().trim() : "";
          if (dobValue !== "") {
            const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(19\d{2}|20\d{2})$/;
            if (!dobRegex.test(dobValue)) {
              const errorMessage = "Please enter a complete date in MM/DD/YYYY format.";
              const $errorElement = $('<label class="hs-error-msg custom-form-error">' + errorMessage + '</label>');
              $dobField.closest(".input").after($errorElement);
              $dobField.addClass("custom-field-error");
              isFormValid = false;
            } else if (!isValidDateInternal(dobValue)) {
              const errorMessage = "Please enter a valid date (e.g., 04/30/2024 is valid, but 04/31/2024 is not).";
              const $errorElement = $('<label class="hs-error-msg custom-form-error">' + errorMessage + '</label>');
              $dobField.closest(".input").after($errorElement);
              $dobField.addClass("custom-field-error");
              isFormValid = false;
            }
          }
        }

        if (!isFormValid) {
          event.preventDefault();
        }
      });

      // Generic placeholder logic (as before)
      // This will run after you have explicitly set the placeholder for DOB.
      // If the DOB field has an empty .hs-field-desc (as seems to be the case from your previous HTML),
      // your 'MM/DD/YYYY' placeholder will not be overwritten by this generic loop.
      $form.find(".hs-form-field").each(function () {
        var $fieldContainer = $(this);
        var $inputField = $fieldContainer.find('input, textarea, select');
        var description = $fieldContainer.find('.hs-field-desc').text();

        if ($inputField.length && description) {
          $inputField.attr('placeholder', description);
        }
      });
    },
    onFormSubmit: function ($form) {
      // Prevent the default form submit action which causes the scroll to top
      $form.on('submit', function (e) {
        e.preventDefault();
        // Perform any additional actions you want here
      });
    },

    onFormSubmitted: function () {
      // Prevent scrolling to the top after form submission
      // $form.closest('.modal-body').scrollTop($form.closest('.hs-form').offset().top);

      // Push dataLayer event for TV Ad metrics
      window.dataLayer?.push({
        'event': "home_page_subscription",
        'page_name': "home_page_completion"
      });
    }
  });
});
